<template>
  <main>
    <b-row
      id="id33"
      class="mt-3 rounded-lg save-button-text bg-white"
      style="box-shadow: 0px -4px 4px -2px rgba(23, 38, 74, 0.08); padding: 10px"
    >
      <b-col class="mt-2 submit-style" cols="7">{{ selectionMessage }}</b-col>
      <b-col cols="5">
        <b-button
          :disabled="disabled"
          :variant="submitVariant"
          class="float-right"
          pill
          @click="submitRequest()"
        >
          Submit Request
        </b-button>
        <b-button
          v-if="!this.isAnonymous"
          class="float-right"
          pill
          variant="link"
          @click="$emit('redirectBack')"
          >Cancel
        </b-button>
      </b-col>
    </b-row>
    <submit-request-modal
      :email="userDetails.selectedEmail"
      @proceedToSubmit="collectAndSendData()"
    ></submit-request-modal>
    <saving-modal
      :id="'saveRequest'"
      :busy="busy"
      :errorMessage="errorMessage"
      :modalLoading="modalLoading"
      :modalSuccessMessage="
        'Thank you for submitting an access request. The Pfizer Accounts Provisioning Team will be reviewing your request. You may come back to this page for status updates.'
      "
      :modalTitle="modalTitle"
      :saveResponseStatus="saveResponseStatus"
      @handleOk="savingModalOk()"
    ></saving-modal>
  </main>
</template>

<script>
  import SavingModal from '../utility/SavingModal';
  import SubmitRequestModal from './SubmitRequestModal';
  import { mapGetters } from 'vuex';

  export default {
    components: {
      SavingModal,
      SubmitRequestModal,
    },
    props: {
      checkedRequests: Array,
      siteId: String,
      studyId: String,
      allApplications: Array,
    },
    data() {
      return {
        modalLoading: false,
        modalTitle: '',
        busy: false,
        saveResponseStatus: null,
        disabled: true,
        submitVariant: 'secondary',
        errorMessage: '',
      };
    },
    computed: {
      ...mapGetters(['userDetails']),
      isAnonymous() {
        return 'token' in this.$route.query;
      },
      checkSIP_GPDIP() {
        return (
          (this.$route.name.includes('application-access-manager') &&
            this.$route.query['userListed'] !== 'true') ||
          this.$route.name.includes('custom-application-access') ||
          this.isAnonymous
        );
      },
      selectionMessage() {
        if (this.checkedRequests.length === 0) {
          this.disabled = true;
          this.submitVariant = 'secondary';
          return 'Select the Application you would like to request for';
        } else {
          this.disabled = false;
          this.submitVariant = 'primary';
          return `${this.checkedRequests.length} application(s) Selected`;
        }
      },
    },
    methods: {
      savingModalOk() {
        if (this.saveResponseStatus == 200 || this.saveResponseStatus == 201) {
          if (this.isAnonymous) {
            this.$router.push({ name: 'thank-you' });
          } else {
            this.$router.go();
          }
        } else {
          this.$bvModal.hide('saveRequest');
          let ds = document.getElementById('duplicate-section');
          if (ds) {
            ds.scrollIntoView();
          }
        }
      },
      submitRequest() {
        if (this.$route.name !== 'custom-application-access' && !this.isAnonymous) {
          this.$bvModal.show('submitModal');
        } else {
          this.collectAndSendData();
        }
      },
      async collectAndSendData() {
        this.busy = true;
        this.$bvModal.show('saveRequest');
        let childRequests = [];
        this.checkedRequests.forEach(item => {
          item.systemRole.forEach(role => {
            childRequests.push({
              SystemRoleId: role.id.includes('remove_access') ? null : role.id,
              ApplicationId: item.id,
              RequestType: item.type,
              DeleteReason: role.id.includes('remove_access') ? role.description : null,
              UrgentPriorityRequest: '',
              Status: 'SUBMITTED',
            });
          });
        });

        let payload = {
          StudyID: this.studyId,
          SiteNumber: this.siteId,
          Status: 'SUBMITTED',
          UserFirstName: this.userDetails.firstName,
          UserLastName: this.userDetails.lastName,
          UserEmailId: this.userDetails.selectedEmail,
          UserPhoneNumber: this.userDetails.phoneNumber,
          checkSIP_GPDIP: this.checkSIP_GPDIP ? 'true' : 'false',
          requests: childRequests,
        };
        this.modalTitle = 'Creating request tickets...';
        this.modalLoading = true;
        this.$bvModal.show('saveRequest');
        try {
          let url = `/api/create-access-request`;
          if (this.isAnonymous) {
            url = `/api/anonymous/create-access-request?token=${this.$route.query['token']}`;
            payload['RequestorAuthType'] = this.userDetails.isSipUser ? 'SIP' : 'External';
            if (this.$route.query['requestType'] === 'otherUser') {
              payload['RequestorEmailId'] = this.userDetails.RequestorEmailId;
              payload['RequestorFirstName'] = this.userDetails.RequestorFirstName;
              payload['RequestorLastName'] = this.userDetails.RequestorLastName;
              payload['UserFirstName'] = this.userDetails.UserFirstName;
              payload['UserLastName'] = this.userDetails.UserLastName;
              payload['UserEmailId'] = this.userDetails.UserEmailId;
              payload['UserPhoneNumber'] = this.userDetails.UserPhoneNumber;
            } else if (this.$route.query['requestType'] === 'personal') {
              payload['RequestorEmailId'] = this.userDetails.email;
              payload['RequestorFirstName'] = this.userDetails.firstName;
              payload['RequestorLastName'] = this.userDetails.lastName;
              payload['ExostarId'] = this.userDetails.exostarId;
            }
          }

          let response = await axios.post(url, payload);
          this.saveResponseStatus = response.data['statuscode'];
          if (this.saveResponseStatus == 200 || this.saveResponseStatus == 201) {
            this.modalTitle = 'Access Request Submitted';
          }
        } catch (e) {
          this.saveResponseStatus = e.response.status;
          if (this.saveResponseStatus == 406) {
            let duplicateRequests = this.setupDuplicateRequests(e.response.data['items']);
            this.modalTitle = 'Duplicate requests found!';
            let duplicateList = duplicateRequests
              .map(item => {
                return `<li class="text-danger"><strong>${item.application}</strong> - ${
                  item.isDeleteRequest ? 'Remove Access:' : 'Role(s):'
                } <strong>${item.role}</strong></li>`;
              })
              .join('');
            this.errorMessage =
              'We have found some duplicate requests and cannot proceed with submitting a new request. Please verify your selected applications and roles. If you need more help please contact support.' +
              '</br>' +
              duplicateList;
          } else {
            this.modalTitle = 'Error!';
            this.errorMessage = 'Something went wrong. Please try again or contact support';
          }
          console.error(e);
        }

        this.modalLoading = false;
        this.busy = false;
      },
      setupDuplicateRequests(items) {
        let duplicates = items.map(request => {
          return {
            application: request['applicationName'],
            role: request['systemroleName'] ?? request['deleteReason'],
            isDeleteRequest:
              request['requestType'] === 'Delete Request' ||
              request['requestType'] === 'Deactivate Request',
          };
        });

        this.$emit('setDuplicates', duplicates);
        return duplicates;
      },
    },
  };
</script>

<style>
  .submit-style {
    font-weight: 500;
    font-size: 18px;
    letter-spacing: 0.25px;
    text-align: left;
  }
</style>
